import Controller from 'controllers/controller';
import AjaxModalController from 'controllers/ajax-modal';
import Elements from 'tools/elements';
import jQuery from 'jquery';

class SuitesTemplateController extends Controller {
    condition() {
        return this.app.pageTemplateIs('suites');
    }
    
    ready() {
        this.elements = new Elements;
        
        this.basePathname = window.location.pathname;
        
        console.log('test');

        this.app.on('controllers-initialised', () => {
            this.ajaxModalController = this.app.make(AjaxModalController, {
                endpoint: 'suite',
                modal: 'suite',
                links: '.suite-link'
            })
        });
    }
}

export default SuitesTemplateController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/templates/suites.js